// Footer.js
import React, { useState, useEffect } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { PoweredByAltrac } from './Graphics/PoweredByAltrac'
import AppStore from '../../stores/AppStore'
import styles from '../../../css/footer.module.css'

const Footer = ({ color }) => {
  const [supportPhone, setSupportPhone] = useState('+1 510 248 4141')
  const [supportEmail, setSupportEmail] = useState('support@altrac.io')

  const appStoreChangeListener = () => {
    const {
      support_email: supportEmailFromStore = 'support@altrac.io',
      support_phone: supportPhoneFromStore = '+1 510 248 4141',
    } = AppStore.getCustomerBrand() || {}
    setSupportEmail(supportEmailFromStore)
    setSupportPhone(supportPhoneFromStore)
  }

  useEffect(() => {
    const {
      support_email: supportEmailFromStore = 'support@altrac.io',
      support_phone: supportPhoneFromStore = '+1 510 248 4141',
    } = AppStore.getCustomerBrand() || {}
    setSupportEmail(supportEmailFromStore)
    setSupportPhone(supportPhoneFromStore)

    AppStore.addChangeListener(appStoreChangeListener)

    return () => {
      AppStore.removeChangeListener(appStoreChangeListener)
    }
  }, [])

  return (
    <footer className={`${styles.footer} ${color ? styles.white : ''}`}>
      <p>
        <FormattedMessage
          id='support.phone.label'
          defaultMessage='Call: '
          description='Support phone number'
        />
        {supportPhone}
      </p>
      <p>
        <a href={`mailTo:${supportEmail}`}>
          <FormattedMessage
            id='support.email.label'
            defaultMessage='Email: '
            description='Support email'
          />
          {supportEmail}
        </a>
      </p>
      <p>
        <FormattedMessage
          id='support.time.label'
          defaultMessage='Monday - Friday: 7:00am - 5:00pm'
          description='Support Hours'
        />
      </p>
      <p>{APP_VERSION}</p>
      <p
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '4px',
        }}
      >
        <span style={{ fontSize: '11px', fontWeight: 400 }}>
          <FormattedMessage
            id='footer.poweredBy'
            defaultMessage='Powered by'
            description='Footer attribution label'
          />
        </span>
        <a href='https://altrac.io' target='_blank' rel='noopener noreferrer'>
          <PoweredByAltrac width={80} color={color} />
        </a>
      </p>
    </footer>
  )
}

export default injectIntl(Footer, { withRef: true })
